import React, { useState } from "react";
import NameIcon from "../../../../svgs/inventory-type-name.svg";
import BrandIcon from "../../../../svgs/brand-name.svg";
import ModelIcon from "../../../../svgs/model-name.svg";
import TypeIcon from "../../../../svgs/type.svg";
import InventoryUploadField from "../../../Common/InventoryUploadField";
import { useNotification } from "../../../../../Notifications/NotificationProvider";
import { InventoryService } from "../../../../network/InventoryService";
import FormField from "../../../../../Shared/Form/FormField";

const INVENTORY_TYPE_OPTIONS = [
  {
    value: "",
    label: "Select an inventory type Device/Sim/Other...",
    isPlaceholder: true,
  },
  { value: "device", label: "Device" },
  { value: "sim", label: "Sim" },
  { value: "other", label: "Other" },
];

const InventoryCreateModal = ({
  showInventoryCreateModal,
  setShowInventoryCreateModal,
  onInventoryCreated,
}) => {
  const dispatchNotification = useNotification();
  const [form, setForm] = useState({
    images: [null, null, null],
    name: "",
    brandName: "",
    modelName: "",
    type: "",
    description: "",
  });
  const [formError, setFormError] = useState("");
  const [isCreating, setIsCreating] = useState(false);

  const handleImageChange = (idx, file) => {
    const newImages = [...form.images];
    newImages[idx] = file;
    setForm({ ...form, images: newImages });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "description" && value.length > 300) return;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.brandName || !form.modelName || !form.type) {
      setFormError("Please fill all required fields.");
      return;
    }

    setIsCreating(true);
    setFormError("");

    try {
      const inventoryData = {
        name: form.name,
        brand: form.brandName,
        model: form.modelName,
        type: form.type,
        description: form.description,
        images: form.images.filter((image) => image !== null),
      };

      const response = await InventoryService.createInventory(inventoryData);

      if (response.is_error === 0) {
        dispatchNotification({
          type: "SUCCESS",
          message: "Inventory created successfully!",
        });

        // Clean up image URLs
        form.images.forEach((image) => {
          if (image instanceof File) {
            URL.revokeObjectURL(URL.createObjectURL(image));
          }
        });

        setForm({
          images: [null, null, null],
          name: "",
          brandName: "",
          modelName: "",
          type: "",
          description: "",
        });

        setShowInventoryCreateModal(false);

        if (onInventoryCreated) {
          onInventoryCreated();
        }
      } else {
        throw new Error(response.message || "Failed to create inventory");
      }
    } catch (error) {
      console.error("Error creating inventory:", error);

      let errorMessage = "Failed to create inventory. Please try again.";

      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }

      setFormError(errorMessage);

      dispatchNotification({
        type: "ERROR",
        message: errorMessage,
      });
    } finally {
      setIsCreating(false);
    }
  };

  if (!showInventoryCreateModal) return null;

  return (
    <div
      className="inventory-modal-overlay"
      onClick={() => !isCreating && setShowInventoryCreateModal(false)}
    >
      <form
        className="inventory-modal device-create-modal"
        onClick={(e) => e.stopPropagation()}
        onSubmit={handleSubmit}
      >
        <div className="inventory-modal-header">
          <h3>Add New Inventory Type</h3>
          <button
            className="close-btn"
            type="button"
            onClick={() => !isCreating && setShowInventoryCreateModal(false)}
            disabled={isCreating}
          >
            ×
          </button>
        </div>
        <div className="inventory-modal-body">
          <div className="attachment-upload-row">
            {[0, 1, 2].map((idx) => (
              <InventoryUploadField
                key={idx}
                idx={idx}
                uploadedImage={form.images[idx]}
                handleImageChange={(file) => handleImageChange(idx, file)}
                disabled={isCreating}
              />
            ))}
          </div>
          <FormField
            id="inventory-name"
            name="name"
            type="text"
            title="Inventory Type Name"
            icon={NameIcon}
            value={form.name}
            onChange={handleInputChange}
            placeholder="Enter inventory name..."
            disabled={isCreating}
            required
          />
          <FormField
            id="brand-name"
            name="brandName"
            type="text"
            title="Brand Name"
            icon={BrandIcon}
            value={form.brandName}
            onChange={handleInputChange}
            placeholder="Enter brand name..."
            disabled={isCreating}
            required
          />
          <FormField
            id="model-name"
            name="modelName"
            type="text"
            title="Model Name"
            icon={ModelIcon}
            value={form.modelName}
            onChange={handleInputChange}
            placeholder="Enter inventory model..."
            disabled={isCreating}
            required
          />
          <FormField
            id="inventory-type"
            name="type"
            type="select"
            title="Inventory Type"
            icon={TypeIcon}
            value={form.type}
            onChange={handleInputChange}
            options={INVENTORY_TYPE_OPTIONS}
            disabled={isCreating}
            required
          />
          <FormField
            id="inventory-description"
            name="description"
            type="textarea"
            title="Description"
            value={form.description}
            onChange={handleInputChange}
            placeholder="Enter inventory description..."
            disabled={isCreating}
          />

          {formError && <div className="inventory-form-error">{formError}</div>}
        </div>
        <div className="inventory-modal-footer">
          <button
            className="cancel-btn"
            type="button"
            onClick={() => setShowInventoryCreateModal(false)}
            disabled={isCreating}
          >
            Cancel
          </button>
          <button className="submit-btn" type="submit" disabled={isCreating}>
            {isCreating ? "Creating..." : "Create"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default InventoryCreateModal;
